import Typography from '@mui/material/Typography'
import ContentWithLogoGrid from 'proposals/components/layout/ContentWithLogoGrid'
import View from 'proposals/components/layout/View'
import Logo from 'proposals/components/Logo'
import PageTitle from 'proposals/components/PageTitle'
import { useParams } from 'react-router-dom'
import RequestForProposalFeedback from 'proposals/feedback/RequestForProposalFeedback'
import Box from '@mui/material/Box'
import { useGetRequestForProposalByTokenQuery } from 'proposals/requestForProposal/queries/useRequestForProposalQuery'
import { useTranslation } from 'react-i18next'
import { useProposalStateQuery } from 'proposals/proposal/queries/useProposalQuery'
import { Link as RouterLink } from 'react-router-dom'
import { Button } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const ProposalSendSuccessView: React.FC = () => {
  const { token } = useParams<{ token: string }>()
  const { t } = useTranslation()
  const theme = useTheme()
  const isWidescreen = useMediaQuery(theme.breakpoints.up('md'))

  const { data: proposeState } = useProposalStateQuery(token ?? '')

  // usually gets rfp from cache because RequestForProposalView is already fetched this
  // this way we are more future proof for site refresh etc.
  const { isSuccess, data } = useGetRequestForProposalByTokenQuery(token ?? '')

  const logoUrl =
    data && data.requestForProposal.tenantLogoUrl
      ? data.requestForProposal.tenantLogoUrl
      : '/images/default_logo.png'

  return (
    <View>
      <ContentWithLogoGrid>
        {isSuccess && isWidescreen && (
          <Box sx={{ gridArea: 'logo', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
            <Logo src={logoUrl} />
          </Box>
        )}
        <PageTitle>
          {isSuccess && !isWidescreen && (
            <Box sx={{ mb: 2 }}>
              <Logo src={logoUrl} />
            </Box>
          )}
          <Typography sx={{ lineHeight: 1, fontWeight: 'fontWeightLight' }} variant="h3">
            {t('good-luck')}
          </Typography>
        </PageTitle>
        <Box sx={{ gridArea: 'content' }}>
          <Typography>{t('success-view-text')}</Typography>
          {proposeState && !proposeState.hasBidderContactRegistered && (
            <Typography sx={{ mt: 2 }}>
              {t('success-view-text-2')}{' '}
              <Box sx={{ mt: 1 }}>
                <Button component={RouterLink} to="/vendors/login" variant="contained" color="primary" sx={{ color: 'common.white' }}>
                  {t('to-vendor-portal')}
                </Button>
            </Box>
            </Typography>
          )}
          {proposeState?.hasBidderContactRegistered && (
            <Box sx={{ mt: 2 }}>
              <Button component={RouterLink} to="/vendors" variant="contained" color="primary" sx={{ color: 'common.white' }}>
                {t('to-vendor-portal')}
              </Button>
            </Box>
          )}
          <Box sx={{ mt: 5 }}>
            <RequestForProposalFeedback />
          </Box>
          <div id="hankinta"></div>
        </Box>
      </ContentWithLogoGrid>
    </View>
  )
}

export default ProposalSendSuccessView
